import { render } from "./Loader.vue?vue&type=template&id=54ea8b20&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=54ea8b20&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ea8b20"]])

export default __exports__